import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const MegaMenu = ({ isOpen, onClose, onOpenPopup }) => {
  const [activeCategory, setActiveCategory] = useState('Trademark Services');

  const megaMenuData = {
    'Trademark Services': [
      { 
        name: 'Register Your Trademark', 
        path: '/services/trademark-registration',
        desc: 'Secure brand rights with thorough searches and expert registration services.'
      },
      { 
        name: 'Clearance Search Services', 
        path: '/services/clearance-search',
        desc: 'Ensure brand uniqueness with comprehensive clearance searches.'
      },
      { 
        name: 'Trademark Ownership Transfers', 
        path: '/services/trademark-ownership-transfers',
        desc: 'Smoothly transfer trademark ownership with our expert guidance.'
      },
      { 
        name: 'Submission of Statements of Use', 
        path: '/services/statements-of-use',
        desc: 'Compliantly file Statements of Use for active trademark status.'
      },
      { 
        name: 'Support and Response for Trademark Office Actions', 
        path: '/services/trademark-office-actions',
        desc: 'Navigate challenges with strategic responses to trademark office actions.'
      },
      { 
        name: 'Active Monitoring for Trademark Infringement', 
        path: '/services/trademark-monitoring',
        desc: 'Vigilantly monitor trademarks to protect against potential infringements.'
      },
      { 
        name: 'File TTAB Petition', 
        path: '/services/ttab-petition',
        desc: 'Trust us to handle your TTAB petition safely and professionally.'
      }
    ],
    'Company Formation Services': [
      { 
        name: 'Limited Liability Company', 
        path: '/services/llc-formation',
        desc: 'Establish your LLC with comprehensive formation services.'
      },
      { 
        name: 'C Corporation', 
        path: '/services/c-corporation',
        desc: 'Form a C Corporation for maximum growth and investment potential.'
      },
      { 
        name: 'S Corporation', 
        path: '/services/s-corporation',
        desc: 'Benefit from tax advantages with S Corporation formation.'
      },
      { 
        name: 'Non-Profit', 
        path: '/services/non-profit-formation',
        desc: 'Create a non-profit organization with expert legal guidance.'
      }
    ],
    'Copyright Services': [
      { 
        name: 'Register Your Copyright', 
        path: '/services/copyright-registration',
        desc: 'Protect your creative works with comprehensive copyright registration.'
      },
      { 
        name: 'Assistance for Your Copyright Enforcement', 
        path: '/services/copyright-enforcement',
        desc: 'Defend your rights with strategic copyright enforcement support.'
      },
      { 
        name: 'Copyright Transfers and Licensing Support', 
        path: '/services/copyright-transfers',
        desc: 'Navigate copyright transfers and licensing with expert assistance.'
      },
      { 
        name: 'Legal Representation for Your Copyright', 
        path: '/services/copyright-legal-representation',
        desc: 'Secure professional legal representation for copyright matters.'
      },
      { 
        name: 'Management of Your Copyright Portfolio', 
        path: '/services/copyright-portfolio',
        desc: 'Efficiently manage your copyright assets with our portfolio services.'
      },
      { 
        name: 'Compliance with DMCA Act', 
        path: '/services/dmca-compliance',
        desc: 'Ensure DMCA compliance to protect your digital content.'
      }
    ],
    'Patent Services': [
      { 
        name: 'Search for Existing Patent', 
        path: '/services/patent-search',
        desc: 'Conduct thorough patent searches to avoid infringement.'
      },
      { 
        name: 'Support and Response for Patent Office Actions', 
        path: '/services/patent-office-actions',
        desc: 'Expert responses to patent office actions for successful outcomes.'
      },
      { 
        name: 'Application Submission for Patent', 
        path: '/services/patent-application',
        desc: 'Submit comprehensive patent applications with professional guidance.'
      },
      { 
        name: 'Legal Representation for Patent Protection', 
        path: '/services/patent-legal-representation',
        desc: 'Protect your innovations with expert patent legal representation.'
      }
    ],
    'Legal Services': [
      { 
        name: 'Business Immigration Law', 
        path: '/services/business-immigration',
        desc: 'Navigate business immigration with expert legal counsel.'
      },
      { 
        name: 'Due Diligence Process', 
        path: '/services/due-diligence',
        desc: 'Conduct thorough due diligence for informed business decisions.'
      },
      { 
        name: 'IT & Commercial Law', 
        path: '/services/it-commercial-law',
        desc: 'Expert guidance on IT and commercial legal matters.'
      },
      { 
        name: 'Legal Services on Partnerships & LLPs', 
        path: '/services/partnerships-llps',
        desc: 'Professional legal services for partnerships and LLPs.'
      },
      { 
        name: 'Data Protection & Privacy Law', 
        path: '/services/data-protection',
        desc: 'Ensure compliance with data protection and privacy regulations.'
      }
    ],
    'Additional Corporate Services': [
      { 
        name: 'Amazon Brand Registry in the US', 
        path: '/services/amazon-brand-registry',
        desc: 'Protect your brand on Amazon with registry services.'
      },
      { 
        name: 'Bookkeeping Service', 
        path: '/services/bookkeeping',
        desc: 'Professional bookkeeping to keep your finances organized.'
      },
      { 
        name: 'Business Formation Services', 
        path: '/services/business-formation',
        desc: 'Comprehensive services for establishing your business entity.'
      },
      { 
        name: 'Certificate of Good Standing', 
        path: '/services/certificate-good-standing',
        desc: 'Obtain certificates proving your business compliance.'
      },
      { 
        name: 'Company Dissolution', 
        path: '/services/company-dissolution',
        desc: 'Professionally dissolve your company with legal guidance.'
      },
      { 
        name: 'Company Name Change', 
        path: '/services/company-name-change',
        desc: 'Seamlessly change your company name with expert support.'
      },
      { 
        name: 'Company Renewal Services', 
        path: '/services/company-renewal',
        desc: 'Maintain compliance with timely company renewal services.'
      },
      { 
        name: 'Issue Of Shares', 
        path: '/services/issue-shares',
        desc: 'Issue shares with proper legal documentation and guidance.'
      },
      { 
        name: 'Nominee Director & Secretarial Services', 
        path: '/services/nominee-director',
        desc: 'Professional nominee director and secretarial services.'
      },
      { 
        name: 'Tax Advisory & Filing', 
        path: '/services/tax-advisory',
        desc: 'Expert tax advisory and filing services for your business.'
      },
      { 
        name: 'Transfer of Shares', 
        path: '/services/transfer-shares',
        desc: 'Facilitate share transfers with legal expertise.'
      },
      { 
        name: 'CFO Services', 
        path: '/services/cfo-services',
        desc: 'Strategic CFO services to drive your business growth.'
      }
    ]
  };

  const categories = Object.keys(megaMenuData);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black/5 z-40"
        onClick={onClose}
      />
      
      {/* Mega Menu Container */}
      <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2 z-50">
        <div className="w-[1100px] max-w-[95vw]">
          <div className="bg-white shadow-2xl rounded-lg border border-gray-200 overflow-hidden">
            <div className="flex">
              {/* Left Sidebar - Categories */}
              <div className="w-64 bg-gray-50 border-r border-gray-200 py-6">
                <ul className="space-y-1">
                  {categories.map((category) => (
                    <li key={category}>
                      <button
                        onMouseEnter={() => setActiveCategory(category)}
                        className={`w-full text-left px-6 py-3 text-sm transition-colors ${
                          activeCategory === category
                            ? 'text-gray-900 font-medium bg-white border-r-2 border-orange-600'
                            : 'text-gray-600 hover:text-gray-900 hover:bg-white'
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          <span className="text-black">▶</span>
                          {category}
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Middle - Services */}
              <div className="flex-1 p-8">
                <div className="grid grid-cols-2 gap-x-8 gap-y-6 max-h-[480px] overflow-y-auto pr-2 custom-scrollbar">
                  {megaMenuData[activeCategory].map((service, idx) => (
                    <Link
                      key={idx}
                      to={service.path}
                      onClick={onClose}
                      className="group block"
                    >
                      <h3 className="text-sm font-semibold text-orange-700 group-hover:text-orange-800 mb-1 transition-colors">
                        {service.name}
                      </h3>
                      <p className="text-xs text-gray-600 leading-relaxed">
                        {service.desc}
                      </p>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Right Panel - Illustration & CTA */}
              <div className="w-72 bg-gradient-to-br from-gray-50 to-orange-50 p-8 flex flex-col justify-center items-center border-l border-gray-200">
                <div className="text-center">
                  <img 
                    src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=300&fit=crop"
                    alt="Legal professionals"
                    className="w-48 h-48 object-cover rounded-lg mx-auto mb-6 shadow-lg"
                  />
                  <button 
                    onClick={() => {
                      onOpenPopup();
                      onClose();
                    }}
                    className="group cursor-pointer"
                  >
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                      Attorneys with you,
                    </h3>
                    <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-orange-600 transition-colors">
                      every step of the way
                    </h3>
                  </button>
                  <button 
                    onClick={() => {
                      onOpenPopup();
                      onClose();
                    }}
                    className="inline-flex items-center gap-2 text-sm text-white bg-orange-600 hover:bg-orange-700 px-6 py-2.5 rounded-lg font-semibold transition-all hover:shadow-lg hover:scale-105"
                  >
                    Get legal help
                    <span>→</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f9fafb;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }
      `}</style>
    </>
  );
};
